import { UserProfile } from "@yardzen/api-dtos";
import { AxiosResponse } from "axios";
import { apiClient } from "../base-client";
import { createServerApiClient } from "../server-base-client";

const baseUrl = "users";

export interface MailingAddressData {
  addressLine1: string;
  addressLine2?: string;
  city: string;
  state: string;
  zipcode: string;
  latitude: number;
  longitude: number;
}

export interface UpdateUserProfileData {
  firstName?: string;
  lastName?: string;
  phone?: string;
  optIn?: boolean;
  mailingAddress?: MailingAddressData;
  confirmInfoModalCompleted?: boolean;
}

export async function getUserProfile(
  userId: string,
): Promise<AxiosResponse<UserProfile>> {
  return apiClient.get(`${baseUrl}/${userId}/user-profile`);
}

export async function getUserProfileServerClient(
  userId: string,
  authToken: string,
): Promise<AxiosResponse<UserProfile>> {
  const client = await createServerApiClient(authToken);
  return client.get(`${baseUrl}/${userId}/user-profile`);
}

export async function updateUserProfile(
  userId: string,
  data: UpdateUserProfileData,
): Promise<AxiosResponse<UserProfile>> {
  return apiClient.patch(`${baseUrl}/${userId}/user-profile`, data);
}
